import ChartDataLabels from "chartjs-plugin-datalabels";
import { Line as ChartLine } from "react-chartjs-2";
import React from "react";
import { defaultOptions } from "./config/options";

const Line = ({
  width,
  height,
  labels,
  dataset,
  moreDatasets,
  options,
  backgroundColor,
  borderColor,
}) => {
  let datasets = [
    {
      label: "Akurasi (%)",
      data: dataset,
      backgroundColor: backgroundColor || "#E4DFFE",
      borderColor: borderColor || "#5446CD",
    },
  ];

  if (moreDatasets) {
    datasets = datasets.concat(moreDatasets);
  }

  const data = {
    labels: labels,
    datasets: datasets,
  };

  return (
    <ChartLine
      plugins={[ChartDataLabels]}
      options={options || defaultOptions}
      data={data}
      width={width}
      height={height}
    />
  );
};

export default Line;
